import { Box } from "@mui/material";
import {
  ParagraphText,
  UBAppModal,
  UBInput,
  UBRadioBox,
} from "../../../../Libraries";
import { useContext, useEffect, useRef, useState } from "react";
import UBDateSelect from "../../../../Libraries/UBDateSelect";
import { LanguageContext } from "../../../../context/LanguageContext";
import { BankIcon } from "../../../../assets/icons/icon";
import { useWalletContext } from "../../../../context/WalletContext";
import { handleShareDetails } from "../../../../utils";
import { useNavigate, useLocation } from "react-router-dom";
import { formatNum } from "../../../../oscar-pos-core/constants";
import styles from "./styles.module.css";
import AppCollectPayment from "../../AppCollectPayment";
import { useAuthContext } from "../../../../context/AuthContext";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { EMIONBOARDINGSTATUS } from "../../../../constants";

const RecordPaymentModal = ({
  isOpen,
  handleClose,
  title = "",
  className,
  handleConfirm,
  selectedInvoice,
}) => {
  const inputRef = useRef(null);

  const [I18n] = useContext(LanguageContext);
  const { business, user } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedMethod, setSelectedMethod] = useState("Bank");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const { accountInfo, fetchAccountInfo, isAccountLoading } =
    useWalletContext();
  const [receivedAmount, setReceivedAmount] = useState(null);

  const initialError = {
    text: "",
    show: false,
  };

  const [error, setError] = useState(initialError);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => inputRef.current?.focus(), 300);
      if(!accountInfo && user?.phone_number){
        fetchAccountInfo(navigate)
      }
    }
  }, [isOpen]);

  const raastDetail = accountInfo?.emi_onboarding_status === EMIONBOARDINGSTATUS.VERIFIED;

  let isExpense = selectedInvoice.type == "out";

  const roundedAmount = Math.round((selectedInvoice?.amount || 0) * 100) / 100;
  const roundedAdvance = Math.round((selectedInvoice?.advance_amount || 0) * 100) / 100;
  let balance = Math.round((roundedAmount - roundedAdvance) * 100) / 100;

  const handleDate = (date) => {
    if (date) {
      let j_date = new Date(date);
      j_date.setHours(0, 0, 0, 0);

      setSelectedDate(new Date(j_date));
    }else{
      setSelectedDate(new Date());
    }
  };



  const handleValueChange = (value) => {
    const strVal = String(value ?? "");
if (strVal.includes("-")) return;
    if (strVal.includes(".") && (strVal.split(".")[1]?.length ?? 0) > 2) return;
    if (strVal.length > 1 && strVal.startsWith("0") && !strVal.startsWith("0.")) return;

    if (Number(value) > balance) {
      setError({
        text: "Received amount cannot be greater than the total amount.",
        show: true,
      });
      setReceivedAmount(value);
    } else {
      if (error.show) {
        setError(initialError);
      }
      setReceivedAmount(value);
    }
  };

  const handleRecordPayment = () => {
    triggerLogEvent(analytics, "record_payment_confirmed", {
      payment_method: selectedMethod,
      id : selectedInvoice?.id,
      type : selectedInvoice?.type
    });
    const isEmpty =
      receivedAmount === null ||
      receivedAmount === undefined ||
      receivedAmount === "";

    if (isEmpty) {
      if (balance <= 0) {
        document.activeElement?.blur();
        handleConfirm(selectedMethod, selectedDate, 0);
        return;
      }
      inputRef?.current?.focus();
      setError({
        text: "Please enter received amount",
        show: true,
      });
      return;
    }

    if (Number(receivedAmount) === 0) {
      inputRef?.current?.focus();
      setError({ text: "Please enter received amount", show: true });
      return;
    }

    if (error.show) {
      inputRef?.current?.focus();
      return;
    }

    document.activeElement?.blur();
    handleConfirm(selectedMethod, selectedDate, receivedAmount);
  };

  const handleShareClick = async () => {
    let info = accountInfo;

    if (!info && user?.phone_number) {
      info = await fetchAccountInfo(navigate);
    }

    const amountToSend =
      receivedAmount && Number(receivedAmount) > 0 && Number(receivedAmount) < balance
        ? Number(receivedAmount)
        : balance;
    handleShareDetails(
      business.name,
      info,
      selectedInvoice,
      navigate,
      isExpense,
      isExpense ? "record_payment_send_money" : "record_payment_share_details",
      undefined,
      amountToSend,
      location.pathname,
    );
  };

  const handleRouteActivateAccount = () => {
      navigate("/WalletOnboarding")
  }

  return (
    <UBAppModal
      id="record_payment_modal"
      open={isOpen}
      disableRestoreFocus
      className={styles.recordPaymentModal}
      header={{
        title: 
          <ParagraphText className="d-flex align-items-center fontSize20 fontWeight500 newFontColor">
            {title}
          </ParagraphText>
        ,
        handleClose: handleClose,
        dont_show_cross_icon: true,
      }}
      footer={[
        {
          data: {
            onClick: handleClose,
            title: I18n.cancel,
            id: "mark_as_paid_cancel",
            className: styles.ubSecondaryButton,
          },
        },
        {
          data: {
            onClick: handleRecordPayment,
            title: I18n.record_payment,
            id: "mark_as_paid_confirm",
            className: styles.ubPrimaryButton,
          },
        },
      ]}
    >
      <Box>
        <ParagraphText className="fontSize14 fontWeight400 newFontColor">
          {I18n.payment_method}
        </ParagraphText>

        <Box className={styles.radioBoxWrapper}>
          <UBRadioBox
            label={I18n.bank}
            onChange={(value) => {
              triggerLogEvent(analytics, "record_payment_method_selected", { method: value });
              setSelectedMethod(value);
            }}
            value={selectedMethod}
          />

          <UBRadioBox
            label={I18n.cash}
            onChange={(value) => {
              triggerLogEvent(analytics, "record_payment_method_selected", { method: value });
              setSelectedMethod(value);
            }}
            value={selectedMethod}
          />
        </Box>

        <AppCollectPayment
          visible={true}
          status={"Paid"}
          hasRaastDetail={!!raastDetail}
          onViewQR={handleShareClick}
          onGetQR={handleRouteActivateAccount}
          loading={isAccountLoading}
          isSale={true}
          customLinkText={isExpense ? I18n.send_money : raastDetail ? I18n.share_details : I18n.getQR}
          customMessage={
            isExpense ? "Make payments with bank transfer. 100% free." : ""
          }
          customIcon={
            isExpense ? <BankIcon height="14px" width="14px" /> : ""
          }
        />

        <Box className={styles.markAsPaidDateBoxWrapper}>
          <ParagraphText className="fontSize14 fontWeight400 newFontColor">
            {I18n.paid_on}
          </ParagraphText>

          <UBDateSelect
            id="invoice_pay_date"
            selectedDate={selectedDate}
            setSelectedDate={handleDate}
            title={null}
            placeholder={I18n.select_date}
            isCalendericon
          />
        </Box>

        <Box className={styles.inputContainer}>
          <UBInput
            baseClassname={styles.recordPaymentAmountInputWrapper}
            inputId="record_payment_amount_input"
            label={I18n.received_amount}
            required
            inputRef={inputRef}
            type="number"
            step="0.01"
            placeholder={I18n.enter_amount_here}
            onChange={(_, value) => handleValueChange(value)}
            error={error}
            prefix={
              <span
                className={`rsPrefix ${error.show ? "foundationRedNormalColor" : "newFontColor"}`}
              >
                Rs.
              </span>
            }
            maxLength={12}
            onKeyDown={(e) => {
              if (e.key === "-" || e.key === "e" || e.key === "E") {
                e.preventDefault();
                return;
              }
              if (e.key === "Enter") {
                e.preventDefault();
                handleRecordPayment();
              }
            }}
            value={receivedAmount}
            infoLabel={
              selectedInvoice?.id ? (
                <Box display={"flex"} alignItems={"center"}>
                  {`${I18n.remaining_amount} Rs. ${error.show
                      ? formatNum(balance)
                      : formatNum(balance - (receivedAmount || 0))
                    }`}
                </Box>
              ) : (
                ""
              )
            }
          />
        </Box>
      </Box>
    </UBAppModal>
  );
};

export default RecordPaymentModal;
